import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-podcast-listing-block',
  templateUrl: './podcast-listing-block.component.html',
  styleUrls: ['./podcast-listing-block.component.css']
})
export class PodcastListingBlockComponent implements OnInit {

  img: any;

  @Input() podcastBlock_item: any = {};

  constructor() { }

  ngOnInit(): void {
    this.img = 'https://' + this.podcastBlock_item.poster
  }

}
